<template>
	<span>
		<span v-if="characteristics.length === 0">{{ emptyText }}</span>
		<template v-else>
			<span
				v-for="(characteristic, i) in preparedCharacteristics"
				:key="characteristic.id + '-' + i"
			>
				<span v-if="i > 0"> | </span>
				<Label
					:characteristic="characteristic"
					:label-type="labelType"
				/>
			</span>
		</template>
	</span>
</template>

<script>
import Label from "@/vue/characteristic/Label";
import _ from "lodash";

export default {
	components: {
		Label
	},

	props: {
		characteristics: {
			type: Array,
			required: true,
		},
		labelType: {
			type: String,
			required: false,
		},
		emptyText: {
			type: String,
			required: false,
		},
		lastLevelOnly: {
			type: Boolean,
			required: false,
		},
	},

	computed: {
		preparedCharacteristics ()
		{
			if (!this.lastLevelOnly)
			{
				return this.characteristics;
			}

			const allIds = _.map(this.characteristics, 'id');

			return _.filter(
				this.characteristics,
				characteristic =>
				{
					const childIds = _.map(characteristic.children || [], 'id');

					return _.intersection(allIds, childIds).length === 0;
				}
			);
		}
	},
}
</script>